import { create } from 'zustand';

// Store the edit navigation tab
export const useEditNavigationStore = create((set) => ({
  customerGranteesTab: null,
  setCustomerGranteesTab: (tab) => set({ customerGranteesTab: tab }),
  clearCustomerGranteesTab: () => set({ customerGranteesTab: null })
}));
